import {
  AlertCircle,
  Apple,
  ArrowUp,
  Baby,
  Backpack,
  BookOpen,
  Check,
  CheckCircle2,
  ChevronLeft,
  ChevronRight,
  CircleDot,
  Copy,
  Droplet,
  Droplets,
  Eye,
  EyeOff,
  Footprints,
  HardHat,
  House,
  Image,
  ImagePlus,
  Info,
  Loader,
  LogIn,
  LogOut,
  MessageCircle,
  Milk,
  Minus,
  MonitorSmartphone,
  Moon,
  Package,
  Pencil,
  PersonStanding,
  Plus,
  RefreshCw,
  RotateCcw,
  Send,
  Settings,
  Share2,
  Shirt,
  Smile,
  Sparkles,
  Sun,
  Trash2,
  TrendingDown,
  TrendingUp,
  Umbrella,
  UserPlus,
  Utensils,
  X,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Icon registry.
 *
 * Deliberately an explicit map rather than `import { icons } from 'lucide-react'`
 * — that pulls all ~1,700 glyphs into the bundle and defeats tree-shaking,
 * which on a phone app opened at 3am is not a trade worth making.
 *
 * Icon names travel with data (prep items and activity rows store a name
 * string), so anything referenced by a Firestore document must be listed here.
 * Add the import above when you add a new choice to `ICON_CHOICES` in the prep
 * screen or to `MILESTONE_SUGGESTIONS`.
 */
export const ICONS = {
  AlertCircle,
  Apple,
  ArrowUp,
  Baby,
  Backpack,
  BookOpen,
  Check,
  CheckCircle2,
  ChevronLeft,
  ChevronRight,
  CircleDot,
  Copy,
  Droplet,
  Droplets,
  Eye,
  EyeOff,
  Footprints,
  HardHat,
  House,
  Image,
  ImagePlus,
  Info,
  Loader,
  LogIn,
  LogOut,
  MessageCircle,
  Milk,
  Minus,
  MonitorSmartphone,
  Moon,
  Package,
  Pencil,
  PersonStanding,
  Plus,
  RefreshCw,
  RotateCcw,
  Send,
  Settings,
  Share2,
  Shirt,
  Smile,
  Sparkles,
  Sun,
  Trash2,
  TrendingDown,
  TrendingUp,
  Umbrella,
  UserPlus,
  Utensils,
  X,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

/** True when `name` is an icon this build can render. */
export function isIconName(name: string): name is IconName {
  return name in ICONS;
}

/**
 * Fallback for a name stored in Firestore that this build does not know —
 * a prep item created by a newer version of the app, say. Renders as a
 * neutral box rather than a hole in the layout.
 */
export const FALLBACK_ICON: LucideIcon = Package;
